import { CommentWithReplyListController } from "@bakbak/controller";
import * as React from "react";
import { ReplyListView } from "../../reply/list/ReplyListView";
import { ReplyCountComponent } from "../../shared/ReplyCountComponent";


interface Props {
	commentId: string;
}

interface State {
	showTotalReplies: boolean;
};

export class CommentWithReplyListConnector extends React.PureComponent<Props, State> {
	state = { showTotalReplies: false };
	unsubscribe: () => void;

	componentWillUnmount() {
		if (this.unsubscribe) {
			this.unsubscribe();
		}
	}

	toggleTotalReplies = (e: any) => {
		e.preventDefault();
		this.setState((prevState: any) => ({
			showTotalReplies: !prevState.showTotalReplies
		}));
	}

	render() {
		const { commentId } = this.props;
		return (
			<CommentWithReplyListController commentId={commentId}>
				{(data) => {
					const { commentWithReplies, commentWithRepliesLoading, subscribe } = data;
					if (commentWithRepliesLoading || !commentWithReplies) {
						return <div>...loading</div>;
					}
					if (!this.unsubscribe) {
						this.unsubscribe = subscribe();
					}
					const { replies } = commentWithReplies;
					return (
						<div>
							<div style={{ marginLeft: 50, marginTop: 8 }}>
								<ReplyCountComponent replyCount={replies ? replies.length : 0} toggleReply={this.toggleTotalReplies} />
							</div>
							<div style={{ marginLeft: 25 }}>
								{this.state.showTotalReplies && replies && <ReplyListView replyList={replies} />}
							</div>
						</div>
					);
				}}
			</CommentWithReplyListController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/modules/comment/details/CommentWithReplyListConnector.tsx